<template>
    <crud-create :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @create="create"
                 @close="$emit('close')"
    >
        <locality-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-create>
</template>

<script>

    import LocalityProvider from "../../../../providers/LocalityProvider";
    
    import {CrudCreate, ClientError} from '@dracul/common-frontend'
    
    import LocalityForm from "../LocalityForm";
    
    


    export default {
        name: "LocalityCreate",
         
        components: { LocalityForm, CrudCreate },
        
        props:{
          open: {type: Boolean, default: true}
        },
        
        data() {
            return {
                title: 'maps.locality.creating',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                form: {
                    locality: ''
                }
            }
        },
        
        methods: {
            create() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    LocalityProvider.createLocality(this.form).then(r => {
                            if (r) {
                                this.$emit('itemCreated',r.data.createLocality)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }

        },
    }
</script>

<style scoped>

</style>

